export default "__VITE_ASSET__DaaBoYyR__"